import { computed, Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private isLoading = signal(false);
  loadingState = computed(() => this.isLoading())

  setLoading(state: boolean){
    this.isLoading.set(state);
  }
}
